export default __webpack_public_path__ + "static/media/bottom-front.3fb83e62.png";